import { ConsentAcceptanceRequest } from "@ent-regis/entregis-ts-angular/model/consentAcceptanceRequest";
import { InvestorMeetingCreateRequest } from "@ent-regis/entregis-ts-angular/model/investorMeetingCreateRequest";

export interface RegisterInvestorState {
  consent?: ConsentAcceptanceRequest[] | [];
  profile?: RegisterInvestorProfileFormModel | null;
  selectedCompany?: RegisterInvestorCompanySelectionModel[] | []; 
  selectedTime?: RegisterInvestorTimeFormModel | null;
}

export interface RegisterInvestorProfileFormModel {
  coHostName?: string;
  brokerName?: string;
  seminarSubEvent?: boolean;
  attendancePreference?: AttendancePreferenceEnum;

  companyName?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobileNumber?: MobileNumberFormModel;
  extNumber?: string;
  jobTitle?: string;
  department?: string;
  countryId?: number;
  institutionalInvestorTypeId?: number;
  otherInstitutionalInvestorType?: string;

  assistantFirstName?: string;
  assistantLastName?: string;
  assistantEmail?: string;
  assistantMobileNumber?: MobileNumberFormModel;
  assistantExtNumber?: string;
}

export interface RegisterInvestorTimeFormModel {
  slots: InvestorSlotFormModel[];
}

export interface InvestorSlotFormModel {
  slotDate: Date;
  slotId: number;
  slotPeriods: InvestorPeriodFormModel[];
}

export interface InvestorPeriodFormModel {
  slotPeriodId: number;
  isAvailable: boolean;
  startTime: string;
  endTime: string;
  description: string;
}

export interface MobileNumberFormModel {
  number: string;
  internationalNumber: string;
  nationalNumber: string;
  e164Number: string;
  countryCode: string;
  dialCode: string;
}

export enum AttendancePreferenceEnum {
  PHYSICAL = 'PHYSICAL',
  VIRTUAL = 'VIRTUAL',
}

export interface FilterParams {
  exchange?: ('SET' | 'OTHER')[];
  viewJumpplus?: boolean;
  search?: string;
  date?: Date | null;
  fromDate?: Date | string | null;
  toDate?: Date | string | null;
  sector?: string | null;
  order?: 'ASC' | 'DESC';
}

export interface RegisterInvestorCompanySelectionModel {
  registerCompanyId: number | null;
  slotPeriodIds: number[];
  meetingType: InvestorMeetingCreateRequest.MeetingTypeEnum;
  meetingPriority: InvestorMeetingCreateRequest.MeetingPriorityEnum;
}